import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
 
@Injectable({ providedIn: 'root' })
export class BulkupdateEventsService {
 
  private loadActionsSubject = new Subject<void>();
 
  // Observable que escucharán los componentes interesados
  loadActions$ = this.loadActionsSubject.asObservable();
 
  triggerLoadActions() {
    this.loadActionsSubject.next();
  }
}